/* eslint-disable react/prop-types */
import ClearIcon from "@mui/icons-material/Clear";
import React from "react";
import styles from "./AppliedFilter.styles";

function AppliedFilterGrad({ filter, disabled, onRemove }) {
  return (
    <div
      style={{
        ...styles.container,
        ...(disabled ? styles.disabled : {}),
      }}
    >
      <div style={styles.left}>
        <div style={styles.label}>{filter.displayName}</div>
        <div style={styles.value}>{filter.value}</div>
      </div>
      <div style={styles.right}>
        {!disabled && (
          <ClearIcon style={styles.Icon} onClick={() => onRemove(filter.key)} />
        )}
      </div>
    </div>
  );
}

export default AppliedFilterGrad;
